var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeadingX',_vm._b({staticClass:"text-h5 font-semibold",attrs:{"level-offset":"4"}},'HeadingX',{ tag: _vm.tag },false),[(_vm.domProps.textContent)?[_vm._v("\n\t\t"+_vm._s(_vm.domProps.textContent)+"\n\t")]:[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }